import { useMutation } from 'react-query';

import { FREE_TRIAL_COPY } from '../../lang/en-US';
import {
  postTrialUpgradeRequest,
  TrialUpgradeRequestPayload,
} from '../request';

export type TrialUpgradeNotifyHandlers = {
  onNotifySuccess: (message: string) => void;
  onNotifyError: (message: string) => void;
};

export const useTrialUpgradeRequestMutation = (
  onSuccessClose: () => void,
  { onNotifySuccess, onNotifyError }: TrialUpgradeNotifyHandlers
) => {
  const { TOASTS } = FREE_TRIAL_COPY;

  return useMutation({
    mutationFn: (payload: TrialUpgradeRequestPayload) =>
      postTrialUpgradeRequest(payload),
    onSuccess: () => onNotifySuccess(TOASTS.UPGRADE_REQUEST_SUCCESS),
    onError: (error: { message?: string }) =>
      onNotifyError(error?.message || TOASTS.UPGRADE_REQUEST_ERROR),
    onSettled: () => onSuccessClose(),
  });
};
